/* eslint-disable*/
import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Ticks
} from "chart.js";



const TowerWiseCountChart = ({ data  }) =>{

  const maxValue = Math.max(
    ...data.datasets.flatMap(ds => ds.data),
    0
  );

  ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);
const options = {
  indexAxis: "x",
  responsive: true,
  plugins: {
    legend: { display: false },
    datalabels: {
      color: "black",
     anchor: 'end',
    align: 'top',
      font: {
        weight: "bold",
        size: 12,
      },
    },
  },
  scales: {
    x: { 
      beginAtZero: true, 
      grid: { display: false },
     ticks: {
        maxRotation: 30,  
        minRotation: 30  ,
        font: {
          size: 8  // Reduced font size for better fit
        },
      }   
        }, 
    y: { 
            beginAtZero: true, 
      // max:50,
      max: maxValue + 10,
      stepSize: 5 ,
    grid: {display: false}
      // max:50
      
  }
  }
}
return(
  <div style={{ minWidth: 'auto', paddingTop: '40px'}}>
    <Bar data={data} options={options} />
  </div>
);
} 

export default TowerWiseCountChart;
